import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MATERIAL_IMPORTS } from '../../../material/material-imports';
import { CapitalizePipe } from '../../../shared/pipes/capitalize.pipe';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { CkEditorComponent } from '../../../shared/ck-editor/ck-editor.component';
import { SolutionListComponent } from '../solution/solution-list/solution-list.component';
import { ProblemService } from '../../../shared/problem.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ExerciseModel, ProblemModel } from '@generativ/much-smarter-models';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ...MATERIAL_IMPORTS, CapitalizePipe, SpinnerComponent, CkEditorComponent, SolutionListComponent],
  selector: 'app-problem-management',
  templateUrl: './problem-management.component.html',
  styleUrls: ['./problem-management.component.scss']
})
export class ProblemManagementComponent implements OnInit {

  readonly problem = signal<ProblemModel | null>(null);

  constructor(private route: ActivatedRoute,
              private problemService: ProblemService,
              private router: Router) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.problemService.getProblem(+params['problemId']).subscribe(
        problemModel => {
          this.problem.set(problemModel);
        }
      );
    });
  }

  /**
   * On edit
   * @param id
   */
  onEditProblem() {
    this.router.navigate(['../edit'], {relativeTo: this.route});
  }

  /**
   * On edit
   * @param id
   */
  onManageExercise(exercise: ExerciseModel) {
    this.router.navigate([
      '/courses',
      exercise.lesson.course.id,
      'lessons',
      exercise.lesson.id,
      'exercises',
      exercise.id,
      'manage',
    ]);
  }
}
